import { useEffect, useState } from "react";
import { PimentoStar } from "../../../components/Icon/assets/PimentoStar.tsx";

const LOADING_STEPS = [
  "Crafting your experience...",
  "Picking relevant aesthetic for your industry...",
  "Selecting relevant quick actions for your job...",
];

export const LoadingPage = ({ onComplete }: { onComplete: () => void }) => {
  const [loadingStep, setLoadingStep] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      if (loadingStep === LOADING_STEPS.length) {
        onComplete();
      } else {
        setLoadingStep(loadingStep + 1);
      }
    }, 2000);
    setIsLoading(true);
    return () => {
      clearInterval(interval);
    };
  }, [loadingStep, onComplete]);

  return (
    <div className="flex-col-center h-full gap-600">
      <LoadingStar fillPercent={isLoading ? 0.0 : 1.0} />
      <div className="heading-xl text-primary">
        {LOADING_STEPS[loadingStep] || LOADING_STEPS.at(-1)}
      </div>
    </div>
  );
};

// XXX: This is a hack to animate the star for 10 seconds.
// It is actually not synchronized with the loading steps.
const LoadingStar = ({ fillPercent }: { fillPercent: number }) => (
  <div className="relative">
    <PimentoStar size={160} className="fill-[--black-alpha-4]" />
    <PimentoStar
      size={160}
      className="loading-star fill-[--grey-16] absolute top-0 left-0"
      style={{
        clipPath: `inset(${fillPercent * 100}% 0 0 0)`,
        transition: "clip-path 10s cubic-bezier(.4,0,.2,1)",
      }}
    />
  </div>
);
